import React from 'react';
import { ComplexityScale } from '@pwc/pwc-deals-ui';

const ComplexityScaleWrapper = ({
  initial,
  modified,
  highLow,
  showTooltip,
  backgroundColor,
}) => {
  const isModified = initial !== modified;

  return (
    <ComplexityScale
      originalValue={initial}
      originalLabel="Initial"
      modifiedValue={isModified ? modified : null}
      modifiedLabel="Adjusted"
      backgroundColor={backgroundColor}
      highLow={highLow}
      showTooltip={showTooltip && isModified}
    />
  );
};

export default ComplexityScaleWrapper;
